import { CloseOutlined } from "@ant-design/icons";
import {
  Button,
  Collapse,
  ColorPicker,
  Form,
  InputNumber,
  Space,
} from "antd";
import { Color } from "antd/lib/color-picker";
import React from "react";
import { CustomParamsInput } from "../CustomParamsInput";
import { ViewComponentList } from "../ViewComponent/ViewComponentList";
import { MethodList } from "../Method/MethodList";
import { EventsList } from "../Event/EventsList";
import { Phase } from "../../types";

interface PhaseListProps {
  phases?: [Phase];
}

export const PhaseList = (props: PhaseListProps) => {
  const initialValue = {
    sequence: props.phases?.length ? props.phases.length + 1 : 0,
    background_color: "#000000",
    ads: [],
  };

  return (
    <Form.List name="phases">
      {(fields, { add, remove }) => {
        console.log(fields);
        return (
          <div style={{ display: "flex", rowGap: 16, flexDirection: "column" }}>
            {fields.map((field, index) => (
              <Collapse size="small" key={field.key}>
                <Collapse.Panel
                  key={field.name}
                  header={`Phase ${field.name + 1}`}
                  extra={
                    <CloseOutlined
                      
                      onClick={() => {
                        remove(field.name);
                      }}
                    />
                  }
                >
                  <Space direction="horizontal" size="middle">
                    <Form.Item label="Sequence" name={[field.name, "sequence"]}>
                      <InputNumber />
                    </Form.Item>

                    <Form.Item
                      normalize={(value: Color) => `#${value.toHex()}`}
                      label="Background Color"
                      name={[field.name, "background_color"]}
                    >
                      <ColorPicker showText format="hex" />
                    </Form.Item>
                  </Space>
                  <Form.Item label="ADS">
                    <ViewComponentList
                      name={[field.name, "ads"]}
                      views={props.phases?.[index]?.ads}
                      components_names={[
                        ...(props.phases?.[index]?.controls ?? []),
                        ...(props.phases?.[index]?.ads ?? []),
                      ].map((component) => component.name)}
                    />
                  </Form.Item>
                  <Form.Item label="Controls">
                    <ViewComponentList
                      name={[field.name, "controls"]}
                      views={props.phases?.[index]?.controls}
                      components_names={[
                        ...(props.phases?.[index]?.controls ?? []),
                        ...(props.phases?.[index]?.ads ?? []),
                      ].map((component) => component.name)}
                    />
                  </Form.Item>
                  <Form.Item label="Methods">
                    <MethodList name={[field.name, "methods"]} />
                  </Form.Item>
                  <Form.Item label="Events">
                    <EventsList
                      sources={[
                        ...(props.phases?.[index]?.controls ?? []),
                        ...(props.phases?.[index]?.ads ?? []),
                        ...(props.phases?.[index]?.methods ?? []),
                      ].map((component) => component.name)}
                      name={[field.name, "events"]}
                    />
                  </Form.Item>
                  <Form.Item label="Custom Parameters" name="custom_params">
                    <CustomParamsInput />
                  </Form.Item>
                </Collapse.Panel>
              </Collapse>
            ))}

            <Button type="dashed" onClick={() => add(initialValue)} block>
              + Add Phase
            </Button>
          </div>
        );
      }}
    </Form.List>
  );
};
